let jsId = '';

const sessionIdDirective = {
  getJSessionId() {
    if (sessionStorage.sessionId) {
      jsId = sessionStorage.sessionId
    } else {
      jsId = createUUID();
      sessionStorage.sessionId = jsId;
    }
    return jsId;
  },

  setSessionId() {
    let id = this.getJSessionId();
    sessionStorage.setItem('sessionId', id);
  },

  getSessionExpireStatus() {
    let accessToken = sessionStorage.getItem('accessToken');
    if (accessToken) {
      let base64Url = accessToken.split('.')[1];
      let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      let parsedToken = JSON.parse(jsonPayload);
      return parsedToken.exp * 1000 > new Date().getTime();
    }
  },

  getRefreshToken() {
    let refreshToken = JSON.parse(sessionStorage.getItem('IOT_GetCurrentUser'))['AuthenticationResult']['RefreshToken'];
    let base64Url = refreshToken.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    let parsedToken = JSON.parse(jsonPayload);
    //console.log(parsedToken, '=?????????? refresh token')
  }
};

let createUUID = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export default sessionIdDirective;
